export default "__VITE_ASSET__B$6TK_wk__"